import { produce } from "immer";
import * as Actions from "pages/Settings/Signs/store/templatesActions";

const initialState = {
  signatures: []
};

const tempalteReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.SET_TEMPLATES:
      draft.signatures = action.payload;
      break;

    default:
      break;
  }
}, initialState);

export default tempalteReducer;
